// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1H_Jo","validationTips":"StatementDescriptor_validationTips__3yPCz"};